export const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
export const CANALI = ["E-commerce", "Rete fisica", "Generale"];
export const CANALI_VENDITA = ["E-commerce", "Rete fisica"];
export const ALIQUOTE = [22, 10, 4, 0];
// Same normalized key as the backend: case, accents, spaces, punctuation, "&"="and", plural -s ignored.
export const chiaveNome = (s) => (s || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[&+]/g, " and ")
  .split(/[^a-z0-9]+/).filter(Boolean).map((w) => (w.length > 3 && w.endsWith("s") && !w.endsWith("ss") ? w.slice(0, -1) : w)).join("");

export function fmtNum(v, dec = 2) {
  const n = Number(v) || 0;
  const [i, d] = Math.abs(n).toFixed(dec).split(".");
  const int = i.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const neg = n < 0 && Number(Math.abs(n).toFixed(dec)) !== 0;
  return `${neg ? "-" : ""}${int}${dec ? "," + d : ""}`;
}

export const fmtEUR = (v) => `${fmtNum(v)} €`;
export const fmtQty = (v) => fmtNum(v, Number.isInteger(Number(v) || 0) ? 0 : 2);
export const fmtEURshort = (v) => (Math.abs(v) >= 1000 ? `${fmtNum(v / 1000, 1)}k €` : `${fmtNum(v, 0)} €`);
export const fmtPct = (v, dec = 1) => (v == null ? "—" : `${fmtNum(v, dec)}%`);
export const fmtSigned = (v, suffix = "%") => (v == null ? "—" : `${v > 0 ? "+" : ""}${fmtNum(v, 1)}${suffix}`);

export function fmtDate(s) {
  if (!s) return "—";
  const [y, m, d] = s.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
}

export function parseNum(s) {
  if (typeof s === "number") return s;
  if (s == null) return null;
  let t = String(s).trim().replace(/\s|€/g, "");
  if (!t) return null;
  if (t.includes(",")) t = t.replace(/\./g, "").replace(",", ".");
  const n = Number(t);
  return Number.isFinite(n) ? n : null;
}

export const toInput = (n) => (n == null ? "" : String(n).replace(".", ","));
export const round2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100;

export function calcIva(imponibile, aliquota) {
  const iva = round2((imponibile * aliquota) / 100);
  return { iva, totale: round2(imponibile + iva) };
}

export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export const nowPeriod = () => ({ anno: new Date().getFullYear(), mese: new Date().getMonth() + 1 });
export const ymStr = (anno, mese) => `${anno}-${String(mese).padStart(2, "0")}`;
export const fmtYm = (ym) => {
  if (!ym) return "—";
  const [y, m] = ym.split("-");
  return `${MESI[Number(m) - 1]} ${y}`;
};
export const slug = (v) => String(v).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
